export default {
  citys: (state: any) => state.app.citys,
  cacheKeepAlive: (state: any) => state.app.cacheKeepAlive,
};
